module.exports = __webpack_public_path__ + "static/media/bs1.0efa7847.jpeg";